import { FC } from 'react'

interface Props {
  className?: string
}
export const TgChatBot: FC<Props> = ({ className }) => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="32 32 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g filter="url(#filter0_d_29993_17934)">
        <rect x="32" y="32" width="50" height="50" rx="25" fill="url(#paint0_radial_29993_17934)" />
        <rect
          x="32.25"
          y="32.25"
          width="49.5"
          height="49.5"
          rx="24.75"
          stroke="url(#paint1_linear_29993_17934)"
          strokeOpacity="0.32"
          strokeWidth="0.5"
        />
        <path
          d="M54 44.6667C54 43.0099 55.3432 41.6667 57 41.6667C58.6568 41.6667 60 43.0099 60 44.6667C60 46.3236 58.6568 47.6667 57 47.6667C55.3432 47.6667 54 46.3236 54 44.6667Z"
          fill="#FAFAFA"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M57 45.6667C57.5523 45.6667 58 46.1144 58 46.6667V50.6667C58 51.219 57.5523 51.6667 57 51.6667C56.4477 51.6667 56 51.219 56 50.6667V46.6667C56 46.1144 56.4477 45.6667 57 45.6667Z"
          fill="#FAFAFA"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M58.4066 49.6667C60.2301 49.6667 61.6998 49.6667 62.8558 49.8221C64.0559 49.9834 65.0663 50.3286 65.869 51.1312C66.6715 51.9337 67.0167 52.9442 67.1781 54.1444C67.3334 55.3003 67.3334 56.9164 67.3334 58.7399C67.3334 60.5634 67.3334 62.0331 67.1781 63.1891C67.0167 64.3892 66.6715 65.3996 65.869 66.2023C65.0663 67.0048 64.0559 67.35 62.8558 67.5114C61.6998 67.6667 60.2301 67.6667 58.4066 67.6667H57.6421C57.4557 67.9863 57.1718 68.3704 56.7478 68.7475C55.7854 69.6028 54.2027 70.3334 51.6667 70.3334C51.2631 70.3334 50.899 70.0907 50.7437 69.718C50.5885 69.3456 50.6723 68.9163 50.9562 68.6296C51.062 68.5052 51.3597 68.1524 51.4991 67.9414C51.5796 67.8196 51.6529 67.6968 51.7171 67.5751C50.2452 67.4463 49.0465 67.1176 48.1312 66.2023C47.3286 65.3996 46.9834 64.3892 46.8221 63.1891C46.6667 62.0331 46.6667 60.5634 46.6667 58.7399C46.6667 56.9164 46.6667 55.3003 46.8221 54.1444C46.9834 52.9442 47.3286 51.9337 48.1312 51.1312C48.9337 50.3286 49.9442 49.9834 51.1444 49.8221C52.3003 49.6667 53.7701 49.6667 55.5935 49.6667H58.4066ZM53.0001 55C53.5523 55 54.0001 55.4478 54.0001 56V57.3334C54.0001 57.8856 53.5523 58.3334 53.0001 58.3334C52.4478 58.3334 52.0001 57.8856 52.0001 57.3334V56C52.0001 55.4478 52.4478 55 53.0001 55ZM61.0001 55C61.5523 55 62.0001 55.4478 62.0001 56V57.3334C62.0001 57.8856 61.5523 58.3334 61.0001 58.3334C60.4478 58.3334 60.0001 57.8856 60.0001 57.3334V56C60.0001 55.4478 60.4478 55 61.0001 55ZM54.9202 61.1903C54.4791 60.8706 53.8615 60.9627 53.5334 61.4C53.2021 61.8419 53.2916 62.4687 53.7335 62.8C53.7391 62.8038 53.7463 62.8086 53.7547 62.8142C53.8159 62.8544 53.9429 62.9382 54.0099 62.9759C54.1623 63.0616 54.3754 63.1671 54.649 63.2698C55.1981 63.4756 55.9834 63.6667 57.0001 63.6667C58.0169 63.6667 58.8022 63.4756 59.3513 63.2698C59.6249 63.1671 59.8379 63.0616 59.9903 62.9759C60.0574 62.9382 60.1843 62.8544 60.2455 62.8142C60.2539 62.8086 60.2611 62.8038 60.2667 62.8C60.7086 62.4687 60.7982 61.8419 60.4667 61.4C60.1387 60.9627 59.521 60.8706 59.0801 61.1903C59.0103 61.2295 58.8199 61.333 58.649 61.3971C58.3091 61.5246 57.7611 61.6667 57.0001 61.6667C56.2391 61.6667 55.6911 61.5246 55.3513 61.3971C55.1803 61.333 54.9899 61.2295 54.9202 61.1903Z"
          fill="#FAFAFA"
        />
        <path
          d="M45.1153 54.4114C44.7909 54.4642 44.4719 54.5581 44.1667 54.7342C43.7107 54.9975 43.3319 55.3762 43.0687 55.8323C42.8322 56.2419 42.7441 56.6766 42.7043 57.1154C42.6667 57.5305 42.6667 58.1222 42.6667 58.7086C42.6667 59.295 42.6667 59.8009 42.7043 60.2158C42.7441 60.6547 42.8322 61.0894 43.0687 61.499C43.3319 61.955 43.7107 62.3338 44.1667 62.597C44.4715 62.773 44.79 62.8667 45.1139 62.9197C44.9999 61.7479 45 60.3614 45.0001 58.8401C45 57.3125 44.9999 55.6518 45.1153 54.4114Z"
          fill="#FAFAFA"
        />
        <path
          d="M68.8868 62.9197C69.2107 62.8667 69.5292 62.773 69.834 62.597C70.29 62.3338 70.6688 61.955 70.9321 61.499C71.1685 61.0894 71.2567 60.6547 71.2964 60.2158C71.334 59.8007 71.334 59.295 71.334 58.7086C71.334 58.1222 71.334 57.5305 71.2964 57.1154C71.2567 56.6765 71.1685 56.2419 70.9321 55.8323C70.6688 55.3762 70.29 54.9975 69.834 54.7342C69.5288 54.5581 69.2097 54.4642 68.8855 54.4114C69.0008 55.6518 69.0008 57.3123 69.0007 58.8401C69.0008 60.3614 69.0008 61.7479 68.8868 62.9197Z"
          fill="#FAFAFA"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_29993_17934"
          x="0"
          y="0"
          width="114"
          height="114"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="16" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.898039 0 0 0 0 0.443137 0 0 0 0 1 0 0 0 0.16 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_29993_17934" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_29993_17934" result="shape" />
        </filter>
        <radialGradient
          id="paint0_radial_29993_17934"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(32 32) rotate(44.7562) scale(69.2382)"
        >
          <stop stopColor="#E571FF" />
          <stop offset="1" stopColor="#FF8933" />
        </radialGradient>
        <linearGradient id="paint1_linear_29993_17934" x1="57" y1="32" x2="57" y2="82" gradientUnits="userSpaceOnUse">
          <stop stopColor="white" />
          <stop offset="1" />
        </linearGradient>
      </defs>
    </svg>
  )
}
